

export function LoadingView({
    text
}) {

    return (
        <div className="p-3 text-grayP" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div >
                <div className="loader-clousure-movements"> </div>
            </div>
            {text ?? "Cargando..."}
        </div>
    )
    
}